export const TABLE_PEFERENCE = 'TABLE_PEFERENCE';
export const INTERVAL_PEFERENCE = 'INTERVAL_PEFERENCE';
export const UNIT_TYPE_PEFERENCE = 'UNIT_TYPE_PEFERENCE';
export const OPERATING_PLAN_PEFERENCE = 'OPERATING_PLAN_PEFERENCE';
export const LAST_PAGE_SEEN_PREFERENCE = 'lastPageSeen';
export const SELECTED_MARKET_PARTICIPANT_PREFERENCE =
  'selectedMarketParticipant';
export const TIMEZONE_PREFERENCE = 'timezone';
